import BaseStore from 'fluxible/addons/BaseStore';

import {
  addSpot,
  setExpanded,
  setHasDropdown,
  setSelectedSpotId,
  setSpotName
} from '../../spot-selector/spotSelectorSlice';

import { AnalyticsProvider } from 'app/scripts/services/analytics-provider';
import { setSpotId } from 'app/scripts/services/app-state';
import { dispatch, getState } from 'state/store';
import { setSuperAdmin } from '../../auth/authSlice';
import { set4O4Error, setCurrentRoute } from 'state';
import RouteStore from 'app/scripts/stores/route';

/**
 * Temporary store that handles navigation events that couldn't be handled by redux store. NAVIGATE_SUCCESS is dispatched
 * by navigateAction from 'fluxible-router' when a route is successfully navigated to.
 */
export class LegacyNavigationStore extends BaseStore {
  constructor(dispatcher) {
    super(dispatcher);

    this.lastNavigation = null;
  }

  handleNavigateStart() {
    dispatch(set4O4Error(false));
  }

  handleNavigateSuccess({ route: currentRoute }) {
    this.dispatcher.waitFor(RouteStore, () => {
      if (currentRoute) {
        dispatch(setCurrentRoute(currentRoute));
      }
    });

    if (currentRoute.tabView) {
      if (this.isNewNavigation(currentRoute)) {
        this.lastNavigation = currentRoute.tabView;
        const pageInfo = `${currentRoute.tabView.first} ${currentRoute.tabView.secondary} page viewed`;
        AnalyticsProvider.track(pageInfo);
      }
    }

    if (currentRoute) {
      const spotId = currentRoute.params.spot_id;
      const { moderation_ticket: ticket, spot_name: spotName } = currentRoute.query;

      const state = getState();

      if (!state) {
        return;
      }

      const { spotSelector } = state;

      if (spotId !== spotSelector.selectedSpotId) {
        dispatch(setSelectedSpotId(spotId));
      }

      dispatch(setExpanded(false));

      if (currentRoute.name === 'createSpot') {
        dispatch(setHasDropdown(false));
        dispatch(setSelectedSpotId(null));

        setSpotId(spotId);
      } else {
        dispatch(setHasDropdown(true));
        const { name, token, network_name: networkName } = currentRoute.query;
        const isSuperAdmin = name && token && networkName;

        if (isSuperAdmin) {
          dispatch(setSuperAdmin({ spotId, status: 'none' }));
          dispatch(addSpot({ id: spotId, name, token, networkName }));
        }
      }

      if (ticket) {
        // todo: handle ticket
        // this.moderationTicket = ticket;
        dispatch(setHasDropdown(false));
        if (spotName) {
          dispatch(setSpotName(spotName));
        }
      }
    }
  }

  handleNavigateFailure(reason) {
    if (reason && reason.statusCode === 404) {
      dispatch(set4O4Error(true));
    }
  }

  isNewNavigation(currentRoute) {
    if (!this.lastNavigation) {
      return true;
    } else {
      return (
        currentRoute.tabView.first !== this.lastNavigation.first ||
        currentRoute.tabView.secondary !== this.lastNavigation.secondary
      );
    }
  }
}

LegacyNavigationStore.storeName = 'LegacyNavigationStore';
LegacyNavigationStore.handlers = {
  NAVIGATE_SUCCESS: 'handleNavigateSuccess',
  NAVIGATE_START: 'handleNavigateStart',
  NAVIGATE_FAILURE: 'handleNavigateFailure'
};
